<div class="challenge-rules-content">
  <!-- Embedded preview (when URL is available) -->
  <section id="challenge-rules-preview-section" class="challenge-rules-content--preview" *ngIf="rulesPreviewUrl">
    <h3 class="challenge-rules-content--preview-title">Preview</h3>
    <div class="challenge-rules-content--preview-frame">
      <iframe
        [src]="rulesPreviewSafeUrl"
        title="Rules and Guidelines PDF preview"
        class="challenge-rules-content--iframe"
      ></iframe>
    </div>
  </section>

  <div class="challenge-rules-content--download">
    <div class="challenge-rules-content--icon-large">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      </svg>
    </div>
    <p class="challenge-rules-content--text">Download the complete Rules and Guidelines document</p>
    <div class="challenge-rules-content--actions">
      <button
        class="challenge-rules-content--button challenge-rules-content--button-secondary"
        (click)="onPreviewClick()"
        [disabled]="loadingPreview || disableActions"
        type="button"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
        <span>{{ loadingPreview ? 'Loading…' : 'Preview' }}</span>
      </button>
      <button
        class="challenge-rules-content--button"
        (click)="onDownloadClick()"
        [disabled]="disableActions"
        type="button"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
        <span>Download PDF</span>
      </button>
    </div>
  </div>
</div>


